export const ADDRESS_LINK =
  'https://www.google.com/maps/place/Giavaneers+Inc/@36.9734554,-122.0238063,13.98z/data=!4m5!3m4!1s0x808e402f60802e1f:0x8b8839609c981c4e!8m2!3d36.9763384!4d-122.0271067';
